import { use } from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options

const i18nInstance = use(Backend) // load translation using http -> see /public/locales - learn more: https://github.com/i18next/i18next-http-backend
  .use(LanguageDetector) // detect user language - learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    load: 'languageOnly',
    ns: ['common'],
    fallbackLng: 'it',
    debug: process.env.NODE_ENV !== 'production',
  });

export default i18nInstance;
